module.exports = __webpack_public_path__ + "static/media/products-bg.bdc11661.webp";